import { type ReactNode } from "react";
import { type LendingAuthMode, LendingHostContext } from "./LendingHostContext";

interface LendingHostProviderProps {
  authMode?: LendingAuthMode;
  /** Host-owned logout handler; see `LendingHostContextValue.onLogout`. */
  onLogout?: () => void;
  children: ReactNode;
}

export function LendingHostProvider({
  authMode = "lending_session",
  onLogout,
  children,
}: LendingHostProviderProps) {
  return (
    <LendingHostContext.Provider value={{ authMode, onLogout }}>
      {children}
    </LendingHostContext.Provider>
  );
}
